/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Fragment, useMemo } from 'react'
import { useSelector } from 'react-redux'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { useI18n } from '@popety_io/popety-io-lib'
import { Typography } from '@mui/material'

import { estimateSelector } from '../../redux'
import GridHeader from '../Configuration/GridHeader'
import GridData from '../Configuration/GridData'
import CollapseList from './LandSummaryContent/CollapseList'
import { getRddfLandLink } from './utils'

const AffectationZone = ({ data }: { data: any }) => {
  const { t } = useI18n()
  const estimate = useSelector(estimateSelector)

  const sortedLandUsePlans = useMemo(
    () =>
      data?.land_use_plans
        ?.map((lup: Record<string, any>) => lup)
        ?.sort(
          (a: { cover_area_perc: number }, b: { cover_area_perc: number }) =>
            b.cover_area_perc - a.cover_area_perc,
        ),
    [data],
  )

  const landUsePlan = sortedLandUsePlans?.[0]

  const items = sortedLandUsePlans?.map(
    (lup: Record<string, any>) =>
      `${lup?.name} - ${lup.cover_area_perc * 100}%`,
  )

  const region = estimate?.regionsByName
    ? estimate?.regionsByName[data?.region_name]
    : null

  const rddfLink = useMemo(
    () => getRddfLandLink(data, region?.rdppf_link),
    [data, region],
  )

  const data1 = [
    {
      label: t('common.type'),
      value:
        (landUsePlan?.plan_type || '') +
        (landUsePlan?.adoption_date
          ? ` ${t('land.underExploited.adopted')} ${landUsePlan?.adoption_date}`
          : ''),
      name: '',
    },
    {
      label: t('common.name'),
      value: landUsePlan?.plan_name,
      name: 'planName',
    },
    {
      label: 'RDPPF',
      value: (
        <>
          {rddfLink ? (
            <Box
              component="a"
              href={rddfLink}
              target="_blank"
              rel="noopener noreferrer"
              color="#2196F3"
            >
              {t('common.land.Télécharger le cadatre RDPPF')}
            </Box>
          ) : (
            '-'
          )}
        </>
      ),
      name: 'rdppf',
    },
  ]

  const data2 = [
    {
      label: 'Label 1',
      value: <CollapseList items={items} moreKey="common.seeMoreAddresses" />,
      name: 'value 1',
    },
  ]

  return (
    <Box
      sx={{
        marginTop: '10px',
      }}
    >
      <GridHeader title="ZONES D'AFFECTATION" />
      <Box
        sx={{
          backgroundColor: '#F9F9F9',
          padding: '6px',
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <GridData data={data1} title="Identification" />
          </Grid>
          <Grid item xs={6}>
            <Typography
              fontSize="1rem"
              fontWeight="500"
              sx={{
                marginBottom: '4px',
              }}
            >
              {t('common.Zone(s)')}
            </Typography>
            {data2?.map((item: any) => (
              <Fragment key={item.label as string}>
                <Grid item xs={12} sm={8}>
                  {item.value}
                </Grid>
              </Fragment>
            ))}{' '}
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default AffectationZone
